export interface StrapiComponentBazaarvoice {
  bazaarvoice_id: string;
  hidden: boolean;
  widget_type: string;
}

const Bazaarvoice = ({ content }: { content: StrapiComponentBazaarvoice }) => {
  const widgetClass = () => {
    switch (content.widget_type) {
      case 'rating_summary':
        return 'flex flex-row items-center justify-center gap-2 pt-10';
      case 'reviews':
        return 'mx-auto mb-9 w-full max-w-screen-2xl px-5 md:px-16 xl:px-[7.5rem]';
      default:
        return 'flex flex-row items-center justify-center gap-2 pt-10';
    }
  };

  return (
    <div
      className={widgetClass()}
      data-bv-show={content.widget_type}
      data-bv-product-id={content.bazaarvoice_id}
    ></div>
  );
};
export default Bazaarvoice;
